
import { all, call, put, takeEvery } from 'redux-saga/effects'
import history from '../history'

import {
    createActionTypes,
    clearOperationSuccess
} from '../common/client/sagas/common';

import {
    ERROR_CLEAR_ACTION_TYPE,
    ERROR_CREATE_ACTION_TYPE ,
    ERROR_OPERATION_SUCCESS_ACTION_TYPE
} from '../common/client/sagas/operationStatus';
import getPromiseCallback from '../common/client/utils/getPromiseCallback';

export const GET_PROJECT_ACTION_TYPE = createActionTypes('project/GET_PROJECT', 'Načítání projektu');
export const IMPORT_KN_DATA_ACTION_TYPE = createActionTypes('project/IMPORT_KN_DATA');
export const CREATE_PROJECT_ACTION_TYPE = createActionTypes('project/CREATE_PROJECT');
export const DELETE_PROJECT_ACTION_TYPE = createActionTypes('project/DELETE_PROJECT', 'Smazání projektu');
export const UPDATE_DATA_FROM_SOURCE_ACTION_TYPE = createActionTypes('project/UPDATE_DATA_FROM_SOURCE', 'Aktualizace dat ze zdroje');

export const RESET_PROJECT = 'project/RESET_PROJECT';
export const REFRESH_PROJECT_ACTION_TYPE = 'project/REFRESH_PROJECT';
export const SET_PROJECT_STATUS_ACTION_TYPE = 'project/SET_PROJECT_STATUS';

export default function getActions(dispatch) {
    return {
        delete: (token, id) => dispatch({
            type: DELETE_PROJECT_ACTION_TYPE.DEFAULT, token, id
        }),
        importKnData: (token, id) => dispatch({
            type: IMPORT_KN_DATA_ACTION_TYPE.DEFAULT, token, id
        }),
        refresh: (token, id) => dispatch({
            type: REFRESH_PROJECT_ACTION_TYPE, token, id
        }),
        updateDataFromSource: (token, id) => dispatch({
            type: UPDATE_DATA_FROM_SOURCE_ACTION_TYPE.DEFAULT, token, id
        })
    };
}

function createProject(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'createProject',
            token: action.token,
            body: {
                params: action.params
            },
            callback: getPromiseCallback(
                resolve, reject
            )
        });
    });
}

function deleteProject(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'deleteProject',
            token: action.token,
            body: {
                id: action.id
            },
            callback: getPromiseCallback(
                resolve, reject
            )
        });
    });
}

function getProject(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callGet({
            module: 'project',
            name: `getProject/${action.id}`,
            token: action.token,
            callback: getPromiseCallback(
                resolve, reject
            )
        });
    });
}

function importKnData(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'importKnData',
            token: action.token,
            body: {
                id: action.id
            },
            callback: getPromiseCallback(
                resolve, reject
            )
        });
    });
}

function updateDataFromSource(serverApi, action) {
    return new Promise((resolve, reject) => {
        serverApi.callPost({
            module: 'project',
            name: 'updateDataFromSource',
            token: action.token,
            body: {
                id: action.id
            },
            callback: getPromiseCallback(
                resolve, reject
            )
        });
    });
}

function* workCreateProject(options, action) {
    try {
        yield put({type: ERROR_CLEAR_ACTION_TYPE});
        const data = yield call(createProject, options.serverApi, action);
        yield put({type: CREATE_PROJECT_ACTION_TYPE.SUCCESS, data: data});
        yield call(history.push, `/projectview/${data.created.id}`);
    } catch (error) {
        yield put({type: CREATE_PROJECT_ACTION_TYPE.FAILED, error});
        yield put({type: ERROR_CREATE_ACTION_TYPE, error});
    }
}

function* workDeleteProject(options, action) {
    try {
        yield put({type: ERROR_CLEAR_ACTION_TYPE});
        const data = yield call(deleteProject, options.serverApi, action);
        yield put({type: DELETE_PROJECT_ACTION_TYPE.SUCCESS, data: data});
        yield put({type: ERROR_OPERATION_SUCCESS_ACTION_TYPE, operation: DELETE_PROJECT_ACTION_TYPE.title});
        yield call(history.push, '/projectList');
        yield call(clearOperationSuccess);
    } catch (error) {
        yield put({type: DELETE_PROJECT_ACTION_TYPE.FAILED, error});
        yield put({type: ERROR_CREATE_ACTION_TYPE, error});
    }
}

function* workImportKnData(options, action) {
    try {
        yield put({type: ERROR_CLEAR_ACTION_TYPE});
        yield call(importKnData, options.serverApi, action);
        yield put({type: REFRESH_PROJECT_ACTION_TYPE, id: action.id});
    } catch (error) {
        yield put({type: IMPORT_KN_DATA_ACTION_TYPE.FAILED, error});
        yield put({type: ERROR_CREATE_ACTION_TYPE, error});
    }
}

function* workUpdateDataFromSource(options, action) {
    try {
        yield put({type: ERROR_CLEAR_ACTION_TYPE});
        yield call(updateDataFromSource, options.serverApi, action);
        yield put({type: REFRESH_PROJECT_ACTION_TYPE, id: action.id});
    } catch (error) {
        yield put({type: UPDATE_DATA_FROM_SOURCE_ACTION_TYPE.FAILED, error});
        yield put({type: ERROR_CREATE_ACTION_TYPE, error});
    }
}

function* workGetProject(options, action) {
    try {
        yield put({type: ERROR_CLEAR_ACTION_TYPE});
        const data = yield call(getProject, options.serverApi, action);
        yield put({type: GET_PROJECT_ACTION_TYPE.SUCCESS, data: data});
        yield put({type: RESET_PROJECT});
    } catch (error) {
        yield put({type: GET_PROJECT_ACTION_TYPE.FAILED, error});
        yield put({type: ERROR_CREATE_ACTION_TYPE, error});
    }
}

function* workRefreshProject(options, action) {
    try {
        const data = yield call(getProject, options.serverApi, action);
        yield put({type: GET_PROJECT_ACTION_TYPE.SUCCESS, data: data});
        yield put({type: RESET_PROJECT});
    } catch (error) {
        // nop;
    }
}

export function* watchGetProject(options) {
    yield all([
        takeEvery(CREATE_PROJECT_ACTION_TYPE.DEFAULT, workCreateProject, options),
        takeEvery(DELETE_PROJECT_ACTION_TYPE.DEFAULT, workDeleteProject, options),
        takeEvery(GET_PROJECT_ACTION_TYPE.DEFAULT, workGetProject, options),
        takeEvery(IMPORT_KN_DATA_ACTION_TYPE.DEFAULT, workImportKnData, options),
        takeEvery(REFRESH_PROJECT_ACTION_TYPE, workRefreshProject, options),
        takeEvery(UPDATE_DATA_FROM_SOURCE_ACTION_TYPE.DEFAULT, workUpdateDataFromSource, options)
    ]);
}
